import { useEffect, useState } from 'react';

import { useTrack } from '@hotjar/webapp/hooks/useTrack';

interface UseRecordingHighlightPreviewProps {
  loaded: boolean | undefined;
  isPlaying: boolean | undefined;
  currentTime: number;
  newHighlightTime: {
    start: number;
    marker: number;
    end: number;
  } | null;
  onPlay: (() => void) | undefined;
  pause: (() => void) | undefined;
  jumpTo?: (targetTime: number) => void;
}

export function useRecordingHighlightPreview({
  loaded,
  isPlaying,
  currentTime,
  newHighlightTime,
  onPlay,
  pause,
  jumpTo,
}: UseRecordingHighlightPreviewProps): { isPlayingStarted: boolean; togglePlayPause: () => void } {
  const [isPlayingStarted, setIsPlayingStarted] = useState<boolean>(false);
  const { click: trackClick } = useTrack();

  useEffect(() => {
    if (onPlay && pause && loaded) {
      if (!isPlaying && isPlayingStarted) {
        setTimeout(() => {
          onPlay();
        }, 500);
      } else if (isPlaying && isPlayingStarted && currentTime >= (newHighlightTime?.end ?? 0)) {
        pause();
        setIsPlayingStarted(false);
      } else if (isPlaying && !isPlayingStarted) {
        pause();
      }
    }
  }, [loaded, isPlaying, isPlayingStarted, currentTime, newHighlightTime, onPlay, pause]);

  const togglePlayPause = () => {
    if (isPlaying && isPlayingStarted) {
      setIsPlayingStarted(false);
    } else if (jumpTo) {
      jumpTo(newHighlightTime?.start || 0);
      setIsPlayingStarted(true);
      trackClick('Create highlight - preview clip', 'clicked_on_highlight_preview_button', {});
    }
  };

  return {
    isPlayingStarted,
    togglePlayPause,
  };
}
